// The fixed 10x10 Sequence board: which card each cell shows.
export const BOARD_LAYOUT = {
    '0,0': 'blank_card',
    '0,1': 'spades_10',
    '0,2': 'spades_queen',
    '0,3': 'spades_king',
    '0,4': 'spades_ace_simple',
    '0,5': 'diamonds_2',
    '0,6': 'diamonds_3',
    '0,7': 'diamonds_4',
    '0,8': 'diamonds_5',
    '0,9': 'blank_card',

    '1,0': 'spades_9',
    '1,1': 'hearts_10',
    '1,2': 'hearts_9',
    '1,3': 'hearts_8',
    '1,4': 'hearts_7',
    '1,5': 'hearts_6',
    '1,6': 'hearts_5',
    '1,7': 'hearts_4',
    '1,8': 'hearts_3',
    '1,9': 'diamonds_6',

    '2,0': 'spades_8',
    '2,1': 'hearts_queen',
    '2,2': 'diamonds_7',
    '2,3': 'diamonds_8',
    '2,4': 'diamonds_9',
    '2,5': 'diamonds_10',
    '2,6': 'diamonds_queen',
    '2,7': 'diamonds_king',
    '2,8': 'hearts_2',
    '2,9': 'diamonds_7',

    '3,0': 'spades_7',
    '3,1': 'hearts_king',
    '3,2': 'diamonds_6',
    '3,3': 'clubs_2',
    '3,4': 'hearts_ace',
    '3,5': 'hearts_king',
    '3,6': 'hearts_queen',
    '3,7': 'diamonds_ace',
    '3,8': 'spades_2',
    '3,9': 'diamonds_8',

    '4,0': 'spades_6',
    '4,1': 'hearts_ace',
    '4,2': 'diamonds_5',
    '4,3': 'clubs_3',
    '4,4': 'hearts_4',
    '4,5': 'hearts_3',
    '4,6': 'hearts_10',
    '4,7': 'clubs_ace',
    '4,8': 'spades_3',
    '4,9': 'diamonds_9',

    '5,0': 'spades_5', 
    '5,1': 'clubs_2',
    '5,2': 'diamonds_4',
    '5,3': 'clubs_4',
    '5,4': 'hearts_5',
    '5,5': 'hearts_2',
    '5,6': 'hearts_9',
    '5,7': 'clubs_king',
    '5,8': 'spades_4',
    '5,9': 'diamonds_10',

    '6,0': 'spades_4',
    '6,1': 'clubs_3',
    '6,2': 'diamonds_3',
    '6,3': 'clubs_5',
    '6,4': 'hearts_6',
    '6,5': 'hearts_7',
    '6,6': 'hearts_8',
    '6,7': 'clubs_queen',
    '6,8': 'spades_5',
    '6,9': 'diamonds_queen',

    '7,0': 'spades_3',
    '7,1': 'clubs_4',
    '7,2': 'diamonds_2',
    '7,3': 'clubs_6',
    '7,4': 'clubs_7',
    '7,5': 'clubs_8',
    '7,6': 'clubs_9',
    '7,7': 'clubs_10',
    '7,8': 'spades_6',
    '7,9': 'diamonds_king',

    '8,0': 'spades_2',
    '8,1': 'clubs_5',
    '8,2': 'spades_ace_simple',
    '8,3': 'spades_king',
    '8,4': 'spades_queen',
    '8,5': 'spades_10',
    '8,6': 'spades_9',
    '8,7': 'spades_8',
    '8,8': 'spades_7',
    '8,9': 'diamonds_ace',

    '9,0': 'blank_card',
    '9,1': 'clubs_6',
    '9,2': 'clubs_7',
    '9,3': 'clubs_8',
    '9,4': 'clubs_9',
    '9,5': 'clubs_10',
    '9,6': 'clubs_queen',
    '9,7': 'clubs_king',
    '9,8': 'clubs_ace',
    '9,9': 'blank_card'
};
